import React, { Component } from 'react';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import AppStore from '../../stores/app-store.js'
import { proximoJogadorActions } from '../../actions/app-actions.js'
import { historiaActions } from '../../actions/app-actions.js'
import { nomeJogadorActions } from '../../actions/app-actions.js'
import { cartaXActions } from '../../actions/app-actions.js'
import { statusCartas } from '../../actions/app-actions.js'
import Snackbar from 'material-ui/Snackbar';
import FlatButton from 'material-ui/FlatButton';
import NovoNome from '../novonome/NovoNome';
import '../../grid.css';
import './Categoria.css';

import { deepOrange500 } from 'material-ui/styles/colors';
import { grey500 } from 'material-ui/styles/colors';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

const muiTheme = getMuiTheme({
    palette: {
        accent1Color: deepOrange500,
    },
});

class Categoria extends Component {
    constructor(props) {
        super(props);
        this.clickAcoes = this.clickAcoes.bind(this);
        this.clickObjetos = this.clickObjetos.bind(this);
        this.clickQualidades = this.clickQualidades.bind(this);
        this.clickLugares = this.clickLugares.bind(this);
        this.clickPersonagens = this.clickPersonagens.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onChangeNomeJogador = this.onChangeNomeJogador.bind(this);
        this.selecionaCarta = this.selecionaCarta.bind(this);
        this.state = {
            estadocartas: AppStore.getCartas(),
            jogadorAtual: AppStore.getJogadorAtual(),
            mensagemSemCarta: false,
            nomeJogador: AppStore.getNomeJogador(),
            mostraMudancaNome: false,
            numAcoes: 0,
            numPersonagens: 0,
            numObjetos: 0,
            numQualidades: 0,
            numLugares: 0,
            legendas: AppStore.legendas,
        };
        this.onChangeLingua = this.onChangeLingua.bind(this);
    }

    static contextTypes = {
        router: React.PropTypes.object.isRequired
    }

    componentWillMount() {

        AppStore.addChangeJogAtualListener(this.onChange);
        AppStore.addChangeNomeJogadorListener(this.onChangeNomeJogador);
        AppStore.addChangeLinguaListener(this.onChangeLingua);
        proximoJogadorActions.proximo();
        historiaActions.sequenciaNumero();
        let eCartas = AppStore.getCartas();
        this.setState({ estadocartas: eCartas });
    }

    componentDidMount() {
        let numAcoes = 0;
        let numPersonagens = 0;
        let numObjetos = 0;
        let numQualidades = 0;
        let numLugares = 0;
        let total = 0;
        let eCartas = this.state.estadocartas;
        for (let i = 0; i < eCartas.length; i++) {
            let carta = eCartas[i];
            if (carta.jogador !== this.state.jogadorAtual) {
                continue;
            }
            if (carta.jaescolhida === true) {
                continue;
            }
            switch (carta.tituloverso) {
                case 'Ações':
                    numAcoes += 1;
                    total += 1;
                    break;
                case 'Lugares':
                    numLugares += 1;
                    total += 1;
                    break;
                case 'Personagens':
                    numPersonagens += 1;
                    total += 1;
                    break;
                case 'Objetos':
                    numObjetos += 1;
                    total += 1;
                    break;
                case 'Qualidades':
                    numQualidades += 1;
                    total += 1;
                    break;
                default:
                    break;
            }
        }
        if (total === 0) {
            this.context.router.push('/mostrahistoria');
        }
        this.setState(
            {
                nomeJogador: AppStore.getNomeJogador(),
                numAcoes: numAcoes,
                numPersonagens: numPersonagens,
                numObjetos: numObjetos,
                numQualidades: numQualidades,
                numLugares: numLugares,
            }
        );
    }

    componentWillUnmount() {
        AppStore.removeChangeJogAtualListener(this.onChange);
        AppStore.removeChangeNomeJogadorListener(this.onChangeNomeJogador);
        AppStore.removeChangeLinguaListener(this.onChangeLingua);
        statusCartas.atualiza(this.state.estadocartas);
    }

    onChangeLingua() {
        this.setState({
            legendas: AppStore.legendas,
        })
    }


    onChange() {
        this.setState({
            jogadorAtual: AppStore.getJogadorAtual(),
        });
    }

    onChangeNomeJogador() {
        this.setState({
            nomeJogador: AppStore.getNomeJogador(),
        });
    }

    selecionaCarta(titulo) {
        let copia = this.state.estadocartas.slice(0);
        let carta = {
            idoriginal: 0,
            key: 0,
            imgfrente: '',
            titulofrente: '',
            imgverso: '',
            tituloverso: '',
            jogador: 0,
            jaescolhida: false,
            frente: false,
            selecionada: false,
        };
        let temCarta = false;
        for (let i = 0; i < copia.length; i++) {
            carta = copia[i];
            if (carta.jogador !== this.state.jogadorAtual) {
                continue;
            }
            if (carta.tituloverso !== titulo) {
                continue;
            }
            if (carta.jaescolhida === true) {
                continue;
            }
            temCarta = true;
            carta.frente = true;
            carta.selecionada = true;
            this.setState({ estadocartas: copia });
            cartaXActions.definirCarta(carta);
            break;

        }
        if (temCarta) {
            this.context.router.push('/cartax');
        } else {
            this.setState({ mensagemSemCarta: true });
        }
    }

    clickAcoes() {
        this.selecionaCarta('Ações');
    }

    clickObjetos() {
        this.selecionaCarta('Objetos');
    }

    clickQualidades() {
        this.selecionaCarta('Qualidades');
    }

    clickLugares() {
        this.selecionaCarta('Lugares');
    }

    clickPersonagens() {
        this.selecionaCarta('Personagens');
    }

    trataRequestClose = () => {
        this.setState({ mensagemSemCarta: false });
    }

    trataBotaoNome = (evento) => {
        this.setState({
            mostraMudancaNome: !this.state.mostraMudancaNome,
        });
    }

    handleInputChange = (event) => {
        this.setState({
            nomeJogador: event.target.value,
        });
        nomeJogadorActions.definirNome(event.target.value);
    };

    render() {
        return (
            <MuiThemeProvider muiTheme={muiTheme}>
                <div className="Categoria">
                    <div>
                        <FlatButton labelStyle={{ fontFamily: 'OpenSans', fontSize: '36px', padding: '10px', color: 'white' }} label={this.state.nomeJogador} onTouchTap={this.trataBotaoNome} />
                    </div>
                    <div>
                        <NovoNome rendered={this.state.mostraMudancaNome} />
                    </div>
                    <div className="ui-g">
                        <div className="ui-g-4" />
                        <div className="ui-g-4">
                            <FloatingActionButton onClick={this.clickAcoes} iconStyle={{ width: '100px', height: '100px' }} backgroundColor='#ed1c24' disabledColor={grey500} disabled={this.state.numAcoes === 0}>
                                <h4>{this.state.legendas.acoes}</h4>
                            </FloatingActionButton>
                        </div>
                        <div className="ui-g-4" />

                        <div className="ui-g-4">
                            <FloatingActionButton onClick={this.clickObjetos} iconStyle={{ width: '100px', height: '100px' }} backgroundColor='#c800c8' disabledColor={grey500} disabled={this.state.numObjetos === 0}>
                                <h4>{this.state.legendas.objetos}</h4>
                            </FloatingActionButton>
                        </div>
                        <div className="ui-g-4" />
                        <div className="ui-g-4">
                            <FloatingActionButton onClick={this.clickQualidades} iconStyle={{ width: '100px', height: '100px' }} backgroundColor='#00a1db' disabledColor={grey500} disabled={this.state.numQualidades === 0}>
                                <h4>{this.state.legendas.qualidades}</h4>
                            </FloatingActionButton>
                        </div>

                        <div className="ui-g-4">
                            <FloatingActionButton onClick={this.clickLugares} iconStyle={{ width: '100px', height: '100px' }} backgroundColor='#f7941e' disabledColor={grey500} disabled={this.state.numLugares === 0}>
                                <h4>{this.state.legendas.lugares}</h4>
                            </FloatingActionButton>
                        </div>
                        <div className="ui-g-4" />
                        <div className="ui-g-4">
                            <FloatingActionButton onClick={this.clickPersonagens} iconStyle={{ width: '100px', height: '100px' }} backgroundColor='#43c800' disabledColor={grey500} disabled={this.state.numPersonagens === 0}>
                                <h4>{this.state.legendas.personagens}</h4>
                            </FloatingActionButton>
                        </div>
                        <Snackbar
                            open={this.state.mensagemSemCarta}
                            message={this.state.legendas.tenteOutra}
                            autoHideDuration={4000}
                            onRequestClose={this.trataRequestClose}
                        />
                    </div>
                </div>
            </MuiThemeProvider>
        );
    }
}
export default Categoria;


// WEBPACK FOOTER //
// ./src/componentes/categoria/Categoria.js